import { z } from 'zod';

export const PendingApprovalSchema = z.object({
    id: z.string().optional(),
    resourceType: z.string().min(1), // document, form_submission, etc.
    resourceId: z.string().min(1),
    resourceName: z.string().optional(),
    requesterId: z.string().optional(),
    approverId: z.string().optional(), // Specific user
    status: z.string().default('pending'),
    priority: z.string().default('medium'),
    requestedAt: z.string().or(z.date()).optional(),
    actionDate: z.string().or(z.date()).optional(),
    comments: z.string().optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});

export const ApprovalActionSchema = z.object({
    comments: z.string().optional(),
    action: z.enum(['approve', 'reject']),
});

export const CreatePendingApprovalSchema = PendingApprovalSchema.omit({ id: true });
export const UpdatePendingApprovalSchema = PendingApprovalSchema;